/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOlafReprocessJobStatusByOrderIdQueryResponse, GetOlafReprocessJobStatusByOrderIdPathParams, GetOlafReprocessJobStatusByOrderId404 } from "../models/GetOlafReprocessJobStatusByOrderId";

export function getGetOlafReprocessJobStatusByOrderIdUrl(orderId: GetOlafReprocessJobStatusByOrderIdPathParams["orderId"]) {
  const res = { method: 'GET', url: `/olaf/reprocess/job-status-by-order/${orderId}` as const }
  return res
}

/**
 * @description Finds and returns the most recent reprocess job for the given order ID(s) within the user's client. The provided orders must exactly match the orders in the job.
 * @summary Get OLAF reprocess job status by order ID
 * {@link /olaf/reprocess/job-status-by-order/:orderId}
 */
export async function getOlafReprocessJobStatusByOrderId(orderId: GetOlafReprocessJobStatusByOrderIdPathParams["orderId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetOlafReprocessJobStatusByOrderIdQueryResponse, ResponseErrorConfig<GetOlafReprocessJobStatusByOrderId404>, unknown>({ method : "GET", url : getGetOlafReprocessJobStatusByOrderIdUrl(orderId).url.toString(), ... requestConfig })
  return res.data
}